import React from 'react'

import {
  FlexBox,
  CTAButton,
  ButtonType,
  FlexDirection,
  JustifyContent,
  ComponentColor,
  ComponentStatus,
} from '@influxdata/clockface'

interface Props {
  nextStep?: string
  status: ComponentStatus
}

const SplashCTA = ({nextStep, status}: Props): JSX.Element => {
  return (
    <FlexBox
      direction={nextStep ? FlexDirection.Column : FlexDirection.Row}
      justifyContent={JustifyContent.Center}
      className="splash--cta-button"
    >
      <CTAButton
        text={nextStep ? 'Continue' : 'Finish'}
        type={ButtonType.Submit}
        color={ComponentColor.Primary}
        status={status}
      />
      {nextStep && (
        <p>
          Next: <strong>{nextStep}</strong>
        </p>
      )}
    </FlexBox>
  )
}

export default SplashCTA
